import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { AlertMessageComponent, AlertModule as CosoAlertModule } from "@coso/alert";
import { ConnectionFormsModule } from "@coso/connection-forms";
import { FormsModule as CosoFormsModule } from "@coso/forms";
import { GridModule } from "@coso/grid";
import { UtilityModule } from "@coso/utility";
import { AlertModule } from "ngx-bootstrap/alert";
import { PopoverModule } from "ngx-bootstrap/popover";
import { TabsModule } from "ngx-bootstrap/tabs";
import { TooltipModule } from "ngx-bootstrap/tooltip";
import { PageHeaderModule } from "../../page-header/page-header.module";
import { ActiveDirectoryComponent } from "./active-directory/active-directory.component";
import { ConnectionsRoutingModule } from "./connections-routing.module";
import { ConnectionsComponent } from "./connections.component";
import { Dynamics365Component } from "./dynamics365/dynamics365.component";
import { EntraIdComponent } from "./entra-id/entra-id.component";

@NgModule({
  declarations: [ConnectionsComponent, ActiveDirectoryComponent, Dynamics365Component, EntraIdComponent],
  imports: [
    CommonModule,
    ConnectionsRoutingModule,
    AlertModule,
    CosoAlertModule,
    PageHeaderModule,
    FormsModule,
    PopoverModule,
    ReactiveFormsModule,
    ConnectionFormsModule,
    UtilityModule,
    CosoFormsModule,
    TabsModule,
    TooltipModule,
    GridModule,
    AlertMessageComponent
  ]
})
export class ConnectionsModule {}
